import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getSmasterReportByCollection=({
    date,
    type
},token)=>async dispatch=>{
    dispatch({
        type:actionTypes.SMASTER_RP_BY_COLLECTION_START,
    })
    const options={
        url:`${api}/reports/daily/smasters?type=${type}&date=${date}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=> dispatch({
                type:actionTypes.SMASTER_RP_BY_COLLECTION_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.SMASTER_RP_BY_COLLECTION_FAIL,
                payload:getMessage(error)
            }))
}